const InputCheckBox = ({ children, label = "", rounded, ...rest }) => {
  return (
    <label className="checkbox-container">
      <input type="checkbox" className="checkbox" {...rest} />
      <span className={rounded ? "round-span" : "square-span"}></span>
      <span className="checkbox-label">{children || label}</span>
    </label>
  );
};

export default InputCheckBox;
